import { CTFModuleTypes, DocumentTypes, StoreState } from 'types';

const getSnackMessage = (state: StoreState) => state.app.snackMessage;

const getUpdatingInspection = (state: StoreState) => state.app.updatingInspection;

const getFetchingResults = (state: StoreState) => state.app.fetchingDifferences;

const getAutosaving = (state: StoreState) => state.app.autosaving;

const getStartingInspection = (state: StoreState) => state.app.startingInspection;

const getResetIdleTimer = (state: StoreState) => state.app.resetIdleTimer;

const getDialogPopUps = (state: StoreState) => state.app.popUpNotifications;

const getUserPreferences = (state: StoreState) => state.app.userPreferences;

const getToastStatuses = (state: StoreState) => state.app.toastStatuses;

const getIntegrations = (state: StoreState) => state.app.integrations;

const getDisplayName = (state: StoreState) => state.app.displayName;

const getShowLiveText = (state: StoreState) => state.app.showLiveText;

const getShowTextHighlights = (state: StoreState) => state.app.showTextHighlights;

const getGrayscaleMode = (state: StoreState) => state.app.grayscaleMode;

const getSinglePageView = (state: StoreState) => state.app.singlePageView;

const getFocusedMatchIndex = (state: StoreState) => state.app.focusedMatchIndex;
const getShowDifferenceBoxes = (state: StoreState) => state.app.showDifferenceBoxes;

const getHideOtherDifferences = (state: StoreState) => state.app.hideOtherDifferences;

const getShowOverlay = (state: StoreState) => state.app.showOverlay;

const getShowRepeats = (state: StoreState) => state.app.showRepeats;

const getGraphicMode = (state: StoreState) => state.app.graphicMode;

const getLastGraphicMode = (state: StoreState) => state.app.lastGraphicMode;

const getTransparencyOpacity = (state: StoreState) => state.app.transparencyOpacity;

const getCloningOperations = (state: StoreState) => state.app.cloningOperations;

const getHasCloningInProgress = (state: StoreState) => state.app.cloningOperations.length > 0;

const getIsCloningModalOpen = (state: StoreState) => state.app.isCloningModalOpen;

const getShouldShowCloningToast = (state: StoreState) =>
  state.app.cloningOperations.length > 0 && !state.app.isCloningModalOpen;

const getCloseConfirm = (state: StoreState) => state.app.closeConfirm;

const getIsReopenedSession = (state: StoreState) => state.app.isReopenedSession;

const getUnavailableFiles = (state: StoreState) => state.app.unavailableFiles;

const getSelectedModule = (state: StoreState) => state.app.selectedModule;

const sourceHiddenModules: CTFModuleTypes[] = [
  CTFModuleTypes.spelling,
  CTFModuleTypes.barcode,
  CTFModuleTypes.braille,
  CTFModuleTypes.fontMetrics,
  CTFModuleTypes.color,
];

/** Returns which document panels should be hidden for a given module selection. */
const getHideDisplayPanelsForModule = (
  selectedModule: CTFModuleTypes | 'All',
): { [key in DocumentTypes]: boolean } => ({
  [DocumentTypes.source]: sourceHiddenModules.includes(selectedModule as CTFModuleTypes),
  [DocumentTypes.target]: false,
});

const getHideDisplayPanels = (state: StoreState) => state.app.hideDisplayPanels;

const getShowMarkupTab = (state: StoreState) => state.app.showMarkupTab;

export {
  getSnackMessage,
  getUpdatingInspection,
  getFetchingResults,
  getAutosaving,
  getStartingInspection,
  getResetIdleTimer,
  getDialogPopUps,
  getUserPreferences,
  getToastStatuses,
  getIntegrations,
  getDisplayName,
  getShowLiveText,
  getFocusedMatchIndex,
  getShowDifferenceBoxes,
  getHideOtherDifferences,
  getShowOverlay,
  getShowTextHighlights,
  getGrayscaleMode,
  getSinglePageView,
  getShowRepeats,
  getGraphicMode,
  getLastGraphicMode,
  getTransparencyOpacity,
  getCloningOperations,
  getHasCloningInProgress,
  getIsCloningModalOpen,
  getShouldShowCloningToast,
  getCloseConfirm,
  getIsReopenedSession,
  getUnavailableFiles,
  getSelectedModule,
  getHideDisplayPanelsForModule,
  getHideDisplayPanels,
  getShowMarkupTab,
};
